export const SET_SELECTED_BOOK_ID = 'SET_SELECTED_BOOK_ID'
export const setSelectedBookId = (id) => ({
  type: SET_SELECTED_BOOK_ID,
  payload: id,
})

export const SET_SELECTED_BOOK_TITLE = 'SET_SELECTED_BOOK_TITLE'
export const setSelectedBookTitle = (title) => ({
  type: SET_SELECTED_BOOK_TITLE,
  payload: title,
})

export const SET_SELECTED_SECTION_ID = 'SET_SELECTED_SECTION_ID'
export const setSelectedSectionId = (id) => ({
  type: SET_SELECTED_SECTION_ID,
  payload: id,
})

export const SET_EDIT_MODE = 'SET_EDIT_MODE'
export const setEditMode = (bool) => ({
  type: SET_EDIT_MODE,
  payload: bool,
})

export const SET_CURRENT_SECTION = 'SET_CURRENT_SECTION'
export const setCurrentSection = (obj) => ({
  type: SET_CURRENT_SECTION,
  payload: obj,
})

export const SET_CURRENT_ADD_SECTION_TO_BOOK_OBJECT =
  'SET_CURRENT_ADD_SECTION_TO_BOOK_OBJECT'
export const setCurrentAddSectionToBookObject = (obj) => ({
  type: SET_CURRENT_ADD_SECTION_TO_BOOK_OBJECT,
  payload: obj,
})

export const SET_CURRENT_EDIT_BOOK_OBJECT = 'SET_CURRENT_EDIT_BOOK_OBJECT'
export const setCurrentEditBookObject = (obj) => ({
  type: SET_CURRENT_EDIT_BOOK_OBJECT,
  payload: obj,
})

export const SET_CURRENT_EDIT_BOOK_ID = 'SET_CURRENT_EDIT_BOOK_ID'
export const setCurrentEditBookId = (obj) => ({
  type: SET_CURRENT_EDIT_BOOK_ID,
  payload: obj,
})

export const SAVE_SECTION = 'SAVE_SECTION'
export const saveSection = () => ({
  type: SAVE_SECTION,
})

export const SAVE_SECTION_SUCCESS = 'SAVE_SECTION_SUCCESS'
export const saveSectionSuccess = () => ({
  type: SAVE_SECTION_SUCCESS,
})

export const SAVE_SECTION_FAILED = 'SAVE_SECTION_FAILED'
export const saveSectionFailed = () => ({
  type: SAVE_SECTION_FAILED,
})

export const SET_CURRENT_EDIT_CLASS_OBJECT = 'SET_CURRENT_EDIT_CLASS_OBJECT'
export const setCurrentEditClassObject = (obj) => ({
  type: SET_CURRENT_EDIT_CLASS_OBJECT,
  payload: obj,
})

export const SET_EDIT_BOOK_PANEL_START_ON_TAB =
  'SET_EDIT_BOOK_PANEL_START_ON_TAB'
export const setEditBookPanelStartOnTab = (label) => ({
  type: SET_EDIT_BOOK_PANEL_START_ON_TAB,
  payload: label,
})

export const ON_NAVIGATION = 'ON_NAVIGATION'
export const onNavigation = (location) => ({
  type: ON_NAVIGATION,
  payload: { location },
})

export const SET_MAIN_ELEMENT = 'SET_MAIN_ELEMENT'
export const setMainElement = (element) => ({
  type: SET_MAIN_ELEMENT,
  payload: { element },
})

export const SET_SHOW_ONBOARDING_PROGRESS_BLOCK =
  'SET_SHOW_ONBOARDING_PROGRESS_BLOCK'
export const setShowOnboardingBlock = (bool) => ({
  type: SET_SHOW_ONBOARDING_PROGRESS_BLOCK,
  payload: bool,
})

export const INCREASE_SHOWN_TOOLTIPS_COUNT = 'INCREASE_SHOWN_TOOLTIPS_COUNT'
export const increaseShownTooltipCount = () => ({
  type: INCREASE_SHOWN_TOOLTIPS_COUNT,
})

export const SET_CURRENT_EXAM = 'SET_CURRENT_EXAM'
export const setCurrentExam = (obj) => ({
  type: SET_CURRENT_EXAM,
  payload: obj,
})

export const SET_CURRENT_ACTIVE_EXAM = 'SET_CURRENT_ACTIVE_EXAM'
export const setCurrentActiveExam = (obj) => ({
  type: SET_CURRENT_ACTIVE_EXAM,
  payload: obj,
})

export const SET_CURRENT_ACTIVE_EXAM_ATTEMPT_ID =
  'SET_CURRENT_ACTIVE_EXAM_ATTEMPT_ID'
export const setCurrentActiveExamAttemptId = (id) => ({
  type: SET_CURRENT_ACTIVE_EXAM_ATTEMPT_ID,
  payload: id,
})

export const SET_CURRENT_SESSION_LATEST_FINISHED_EXAM =
  'SET_CURRENT_SESSION_LATEST_FINISHED_EXAM'
export const setCurrentSessionLatestFinishedExam = (obj) => ({
  type: SET_CURRENT_SESSION_LATEST_FINISHED_EXAM,
  payload: obj,
})

export const SET_CURRENT_EXAM_ATTEMPT_IN_PROGRESS_ID =
  'SET_CURRENT_EXAM_ATTEMPT_IN_PROGRESS_ID'
export const setCurrentExamAttemptInProgressId = (id) => ({
  type: SET_CURRENT_EXAM_ATTEMPT_IN_PROGRESS_ID,
  payload: id,
})

export const ON_CLOSE_EXAM = 'ON_CLOSE_EXAM'
export const onCloseExam = () => ({
  type: ON_CLOSE_EXAM,
})

export const SET_SELECTED_STUDENT = 'SET_SELECTED_STUDENT'
export const setSelectedStudent = (student) => ({
  type: SET_SELECTED_STUDENT,
  payload: student,
})

export const SET_SELECTED_BOOK_FOR_PROGRESS_INSPECTION =
  'SET_SELECTED_BOOK_FOR_PROGRESS_INSPECTION'
export const setSelectedBookForProgressInspection = (book) => ({
  type: SET_SELECTED_BOOK_FOR_PROGRESS_INSPECTION,
  payload: book,
})

export const SET_SELECTED_SECTION_FOR_PROGRESS_INSPECTION =
  'SET_SELECTED_SECTION_FOR_PROGRESS_INSPECTION'
export const setSelectedSectionForProgressInspection = (section) => ({
  type: SET_SELECTED_SECTION_FOR_PROGRESS_INSPECTION,
  payload: section,
})

export const SET_SELECTED_SCHOOL_RESOURCE_FOR_PROGRESS_INSPECTION =
  'SET_SELECTED_SCHOOL_RESOURCE_FOR_PROGRESS_INSPECTION'
export const setSelectedSchoolResourceForProgressInspection = (
  schoolResource
) => ({
  type: SET_SELECTED_SCHOOL_RESOURCE_FOR_PROGRESS_INSPECTION,
  payload: schoolResource,
})

export const SET_SELECTED_SCHOOL_RESOURCE_TYPE_FOR_PROGRESS_INSPECTION =
  'SET_SELECTED_SCHOOL_RESOURCE_TYPE_FOR_PROGRESS_INSPECTION'
export const setSelectedSchoolResourceTypeForProgressInspection = (
  schoolResourceType
) => ({
  type: SET_SELECTED_SCHOOL_RESOURCE_TYPE_FOR_PROGRESS_INSPECTION,
  payload: schoolResourceType,
})

export const SET_SELECTED_INSPECTION_STATUS = 'SET_SELECTED_INSPECTION_STATUS'
export const setSelectedInspectionStatus = (status) => ({
  type: SET_SELECTED_INSPECTION_STATUS,
  payload: status,
})

// Multi-dispatch function
export const clearProgressInspectionStuff = () => (dispatch) => {
  dispatch(setSelectedInspectionStatus(null))
  dispatch(setSelectedSchoolResourceForProgressInspection(null))
  dispatch(setSelectedSchoolResourceTypeForProgressInspection(null))
  dispatch(setSelectedBookForProgressInspection(null))
  dispatch(setSelectedSectionForProgressInspection(null))
}
